import { render } from "./ReportColumnChart.vue?vue&type=template&id=5bad22a6&scoped=true"
import script from "./ReportColumnChart.vue?vue&type=script&lang=js"
export * from "./ReportColumnChart.vue?vue&type=script&lang=js"

import "./ReportColumnChart.vue?vue&type=style&index=0&id=5bad22a6&scoped=true&lang=css"
import "./ReportColumnChart.vue?vue&type=style&index=1&id=5bad22a6&lang=css"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5bad22a6"]])

export default __exports__